import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';

import { VpIcon } from '../VpIcon';

export const StarRating = ({ value = 0, range = [1, 5] }) => {
  const startRange = range[0];
  const endRange = range[1];
  const stars =
    startRange > endRange
      ? [1, 5]
      : Array.from({ length: endRange - startRange + 1 }, (_, i) => startRange + i);

  return (
    <Stack gap="3px" direction="row">
      {stars?.map((star) => (
        <VpIcon
          key={star}
          icon="VpStar"
          size="20px"
          sx={{ color: value >= star ? '#FFCB46' : '#D9D9D9' }}
        />
      ))}
    </Stack>
  );
};

StarRating.propTypes = {
  value: PropTypes.object.string,
  range: PropTypes.object.array
};

export default StarRating;



// WEBPACK FOOTER //
// ./src/vp-ui/components/StarRating/StarRating.jsx